module.exports = {
  language: 'es-ES',

  i18n: {

    'es-ES': {
      'align': 'Alineación',
      'image': 'Imagen',
      'list': 'Listado',
      'link': 'Enlace',
      'unlink': 'Desenlazar',
      'table': 'Tabla',
      'font': 'Fuente',
      'full screen': 'Pantalla completa',
      'text': 'Texto',
      'eraser': 'Borrador',
      'info': 'Información',
      'color': 'Color',
      'please enter a url': 'Por favor, introduce una url',
      'create link': 'Crear enlaze',
      'bold': 'Negrita',
      'italic': 'Cursiva',
      'underline': 'Subrayado',
      'strike through': 'Tachado',
      'subscript': 'Subscript',
      'superscript': 'Superscript',
      'heading': 'Encabezado',
      'font name': 'Fuente',
      'font size': 'Tamaño de fuente',
      'left justify': 'Alinear a la izquierda',
      'center justify': 'Centrar',
      'right justify': 'Justificar',
      'ordered list': 'Lista ordenada',
      'unordered list': 'Lista desordenada',
      'fore color': 'Color principal',
      'background color': 'Color de fondo',
      'row count': 'Número de filas',
      'column count': 'Número de columnas',
      'save': 'Guardar',
      'upload': 'Subir',
      'progress': 'Progreso',
      'unknown': 'Desconocido',
      'please wait': 'Por favor espere',
      'error': 'Error',
      'abort': 'Cancelar',
      'reset': 'Reiniciar'
    }
  },

  hiddenModules: [
    'color',
    'image',
    'eraser',
    'undo',
    'full-screen',
    'info',
    // 'text',
    // 'color',
    // 'font',
    // 'align',
    // 'list',
    'link',
    'unlink',
    // 'tabulation',
    'image'
    // 'hr',
    // 'eraser',
    // 'undo',
    // 'full-screen',
    // 'info'
  ]
}



// WEBPACK FOOTER //
// ./src/utils/wysiwyg_options.js